import script from "./JsonWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./JsonWidget.vue?vue&type=script&setup=true&lang=js"

import "./JsonWidget.vue?vue&type=style&index=0&id=17cd8415&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17cd8415"]])

export default __exports__